module.exports = __webpack_public_path__ + "bb9d19df563ba3bcd629b6abf8375461.pdf";